module.exports = require("osx-temperature-sensor");